import Component from '~/components/component';

export default class BannerHover extends Component {

    _classes = {
        show: 'show'
    }

    constructor(...args) {
        super(...args);

        this.swiper = undefined;
        this.retrieveDOM();
    }

    retrieveDOM() {
        this.dom.views = {};
        this.dom.views.buttonsHover = [];

        if( this.dom.component.dataset.blockParent ) {
            this.dom.views.parent = closest( this.dom.component, '.' + this.dom.component.dataset.blockParent );
        }
        
        if( this.dom.component.dataset.blockParentGlobal ) {
            this.dom.views.parentGlobal = closest( this.dom.component, '.' + this.dom.component.dataset.blockParentGlobal );
        }

        if( this.dom.views.parent ) {
            this.dom.views.buttonsHover = [].slice.call( this.dom.views.parent.querySelectorAll( '.' + this.dom.component.dataset.buttonDetect ) );
        }

        if( this.dom.views.parentGlobal && this.dom.views.parentGlobal.classList.contains( this.dom.component.dataset.buttonDetect ) ) {
            this.dom.views.buttonsHover.push( this.dom.views.parentGlobal );
        }
    }

    bind(){
        [ '_mouseEnterButton', '_mouseLeaveButton' ]
            .forEach((fn) => this[fn] = this[fn].bind(this));
            
        if( this.dom.views.buttonsHover ) {
            for( let i = 0, j = this.dom.views.buttonsHover.length; i < j; i++ ) {
                let element = this.dom.views.buttonsHover[ i ];
                element.addEventListener('mouseenter', this._mouseEnterButton);
                element.addEventListener('mouseleave', this._mouseLeaveButton);
            }
        }
    }

    _mouseEnterButton( event ) {

        if( this.dom.views.parentGlobal ) {
            this.dom.views.parentGlobal.classList.add( this._classes.show );
        }

        if( this.dom.views.parent ) {
            this.dom.views.parent.classList.add( this._classes.show );
        }
        
        this.dom.component.classList.add( this._classes.show );
    }

    _mouseLeaveButton( event ) {

        if( this.dom.views.parentGlobal ) {
            this.dom.views.parentGlobal.classList.remove( this._classes.show );
        }
        if( this.dom.views.parent ) {
            this.dom.views.parent.classList.remove( this._classes.show );
        }
        this.dom.component.classList.remove( this._classes.show );
    }

    /*
    init() {
    }
    bind() {
    }
    unbind() {
    }
    resize(width, height) {
    }
    */
}